import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import GroupIcon from '@mui/icons-material/Group';
import MapIcon from '@mui/icons-material/Map';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import type { Permission } from '@re/shared';
import { tr } from '../lib/i18n';
import type { ReactNode } from 'react';

export type NavItem = {
  to: string;
  label: string;
  /** outlined icon (idle) + filled icon (active) — Google's nav pattern */
  icon: ReactNode;
  activeIcon: ReactNode;
  perms?: Permission[];
  /** a live count shown on the item (e.g. offers waiting for approval) */
  badge?: 'pendingProperties';
};

export const NAV: { label?: string; items: NavItem[] }[] = [
  {
    items: [
      { to: '/dashboard', label: tr('لوحة التحكم', 'Dashboard'), icon: <SpaceDashboardOutlinedIcon />, activeIcon: <SpaceDashboardIcon />, perms: ['dashboard.view'] },
      { to: '/properties', label: tr('العقارات', 'Properties'), icon: <ApartmentOutlinedIcon />, activeIcon: <ApartmentIcon />, perms: ['properties.view.all', 'properties.view.own'], badge: 'pendingProperties' },
      { to: '/map', label: tr('الخريطة', 'Map'), icon: <MapOutlinedIcon />, activeIcon: <MapIcon />, perms: ['properties.view.all', 'properties.view.own'] },
      { to: '/requests', label: tr('الطلبات', 'Requests'), icon: <AssignmentOutlinedIcon />, activeIcon: <AssignmentIcon />, perms: ['requests.view.all', 'requests.view.own'] },
    ],
  },
  {
    label: tr('الإدارة', 'Administration'),
    items: [
      { to: '/users', label: tr('الموظفون', 'Employees'), icon: <GroupOutlinedIcon />, activeIcon: <GroupIcon />, perms: ['users.view', 'users.manage'] },
      { to: '/roles', label: tr('الأدوار والصلاحيات', 'Roles & permissions'), icon: <AdminPanelSettingsOutlinedIcon />, activeIcon: <AdminPanelSettingsIcon />, perms: ['roles.manage'] },
    ],
  },
];

/** pages used for routing but not listed in the side nav */
const EXTRA_PAGES: NavItem[] = [
  { to: '/new', label: tr('إدخال جديد', 'New entry'), icon: <AddCircleOutlineIcon />, activeIcon: <AddCircleOutlineIcon />, perms: ['form.submit'] },
];

/** first page the user may open (used for "/" and after login) */
export function homePath(can: (...p: Permission[]) => boolean): string | null {
  const order = [NAV[0]!.items[0]!, EXTRA_PAGES[0]!, ...NAV.flatMap((g) => g.items).slice(1)];
  for (const it of order) if (!it.perms || can(...it.perms)) return it.to;
  return null;
}
